import React from 'react'

// material ui
import { Box, Grid, Typography } from '@mui/material'

// local components
import Session from './Session'

export default function CamperSessions(props) {
  const { camper, camperSessions } = props

  // render nothing if there are no available days
  if (!camperSessions || !camperSessions.find(cs => cs.registered)) {
    return null
  }

  return (
    <Box>
      {/* Header - only show on larger screens */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          borderBottom: 1,
          borderColor: 'divider',
          pb: 1,
          mb: 2
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography variant='subtitle2' color='text.secondary'>
              Camp Session
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant='subtitle2' color='text.secondary'>
              Days Remaining
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant='subtitle2' color='text.secondary'>
              Days Used
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            {/* Empty header for button column */}
          </Grid>
        </Grid>
      </Box>

      {/* Data rows */}
      {camperSessions.map((camperSession, index) => {
        return (
          <Session
            key={camperSession.id}
            camper={camper}
            camperSession={camperSession}
          />
        )
      })}
    </Box>
  )
}
